import React from 'react';

class Utilities extends React.Component {

    static convertDateToIta(dateToConvert, hoursMinutes = false) {
        let local = new Date(dateToConvert).toLocaleString('it-IT', { timeZone: 'Europe/Rome' })
        let converted = local.split(", ")[0];

        if (hoursMinutes) {
            converted += " " + local.split(", ")[1];
            /* remove last 3 chars */
            converted = converted.substring(0, converted.length - 3);
        }




        /* let date = new Date(dateToConvert);
        let converted = String(date.getDay()).padStart(2, '0') + "/" + String(date.getMonth()).padStart(2, '0') + "/" + String(date.getFullYear()).padStart(2, '0');

        if(hoursMinutes) {
            converted += " " + String(date.getHours()).padStart(2, '0') + ":" + String(date.getMinutes()).padStart(2, '0');
        } */
        return converted;
    }

    static convertDateToEng(dateToConvert, hoursMinutes = false) {
        let local = dateToConvert;
        let converted = local.split(".")[0];
        converted = converted.replace("T", " ");
        let onlyDate = converted.split(" ")[0];
        let onlyTime = converted.split(" ")[1];

        let dateeng = onlyDate.split("-")[2] + "/" + onlyDate.split("-")[1] + "/" + onlyDate.split("-")[0];

        if (hoursMinutes) {
            dateeng += " " + onlyTime;
        }
        return dateeng;
    }

    static isNextExpiration(dateToCheck) {
        let now = new Date();
        let date = new Date(dateToCheck);

        //console.log("now: " + now + " date: " + date)

        return now.getTime() <= date.getTime();
    }

    static convertDateToItaString(dateToConvert, hoursMinutes = false) {
        let local = dateToConvert;
        let converted = local.split(".")[0];
        converted = converted.replace("T", " ");
        let onlyDate = converted.split(" ")[0];
        let onlyTime = converted.split(" ")[1];

        let dateita = onlyDate.split("-")[2] + "/" + onlyDate.split("-")[1] + "/" + onlyDate.split("-")[0];

        if (hoursMinutes) {
            dateita += " " + onlyTime;
        }




        /* let date = new Date(dateToConvert);
        let converted = String(date.getDay()).padStart(2, '0') + "/" + String(date.getMonth()).padStart(2, '0') + "/" + String(date.getFullYear()).padStart(2, '0');

        if(hoursMinutes) {
            converted += " " + String(date.getHours()).padStart(2, '0') + ":" + String(date.getMinutes()).padStart(2, '0');
        } */
        return dateita;
    }

    static convertDateToEngString(dateToConvert, hoursMinutes = false) {
        let splitted = dateToConvert.split(" ");

        let dateNoHour = splitted[0].split("/")[2] + "/" + splitted[0].split("/")[1] + "/" + splitted[0].split("/")[0];

        if (hoursMinutes) {
            if (splitted[1] !== undefined && splitted[1] !== "undefined") {
                return dateNoHour + " " + splitted[1];
            } else {
                return dateNoHour + " 00:00:00";
            }
        } else {
            return dateNoHour;

        }


    }

    static async sleep(ms) {
        return new Promise(r => setTimeout(r, ms));
    }


    static getColor(number){
        switch(number%10){
            case 0:
                return "#99c1f1";
            case 1:
                return "#8ff0a4";
            case 2:
                return "#f9f06b";
            case 3:
                return "#ffbe6f";
            case 4:
                return "#f66151";
            case 5:
                return "#dc8add";
            case 6:
                return "#cdab8f";
            case 7:
                return "#cdab8f";
            case 8:
                return "#00ccff";
            default:
                return "#000000";
        }
    }

}

export default Utilities;